<div class="logo-wrapper">
  <a routerLink="/">
    <h5>DECKorate Console</h5>

    <img class="img-fluid for-dark"
      src="assets/images/logo/rrd-log.svg"
      alt="" />
    </a>
    <button class="back-btn" (click)="sidebarToggle()" aria-label="Go back">
      <i class="fa fa-angle-left"></i>
    </button>
    <button class="toggle-sidebar" (click)="sidebarToggle()" aria-label="Toggle sidebar">
      <app-feather-icons [icon]="'grid'"
      class="status_toggle middle sidebar-toggle"></app-feather-icons>
    </button>
  </div>
  <div class="logo-icon-wrapper">
    <a href="javascript:void(0)">
      <img class="img-fluid"
        src="../../../../assets/images/RR_Donnelley.png"
        alt="" />
      </a>
    </div>
    <nav class="sidebar-main">
      <button type="button"
        class="left-arrow"
        id="left-arrow"
        [class.d-none]="leftArrowNone"
        (click)="scrollToLeft()"
        aria-label="Scroll Left">
        <app-feather-icons [icon]="'arrow-left'"></app-feather-icons>
      </button>
      <div id="sidebar-menu"
         [ngStyle]="{
      marginLeft:
        this.layout.config.settings.layout == 'Rome' ||
        'Singapore' ||
        'Barcelona'
          ? margin + 'px'
          : '0px'
    }">
        <ul class="sidebar-links custom-scrollbar">
          <div class="simplebar-wrapper">
            <div class="simplebar-mask">
              <div class="simplebar-offset">
                <div class="simplebar-content-wrapper">
                  <div class="simplebar-content" style="margin-top: 24px">
                    @for (menuItem of menuItems; track menuItem) {
<li [class]="
                    menuItem.headTitle1 ? 'sidebar-main-title' : 'sidebar-list'
                  "
                        [ngClass]="{ active: menuItem.active }">
                        @if (menuItem.type === 'link' && checkRole(menuItem.role)) {
                          <a [routerLink]="!menuItem.type ? null : [menuItem.path]"
                            routerLinkActive="active"
                            class="sidebar-link sidebar-title"
                            [class.link-nav]="!menuItem.children"
                            [ngClass]="{ active: menuItem.active }"
                            ngbTooltip="{{ menuItem.title | translate }}"
                            placement="right"
                            container="body"
                            tooltipClass="sidebar-tooltip"
                            [openDelay]="150"
                            [disableTooltip]="!navServices.collapseSidebar"
                            >
                            <app-svg-icon [icon]="menuItem.icon"></app-svg-icon>
                            @if (!navServices.collapseSidebar) {
                              <span>
                                {{
                                menuItem.title | translate
                                }}
                              </span>
                            }
                            <div class="according-menu">
                              @if (menuItem.children) {
<i class="fa fa-angle-{{
                          menuItem.active ? 'down' : 'right'
                        }} pull-right"
                                ></i>
                              }
                            </div>
                          </a>
                        }
                      </li>
                    }

                    <li class="toggle-icon-container">
                      <button type="button"
                        [ngClass]="{
            'toggle-bar': !navServices.collapseSidebar,
            'toggle-bar-inverse': navServices.collapseSidebar}"
                        (click)="sidebarToggle()"
                        aria-label="Toggle Sidebar">
                        <img class="img-icon"
                         [src]="!navServices.collapseSidebar
                    ? 'assets/images/feed/slider-icon.svg'
                    : 'assets/images/feed/slider-inverse.svg'"
                          alt="Toggle Sidebar" />
                        </button>
                      </li>

                      <li class="sidebar-list notification">
                        <a href="javascript:void(0)"
                          class="sidebar-link sidebar-title"
                          ngbTooltip="Notification"
                          placement="right"
                          container="body"
                          tooltipClass="sidebar-tooltip"
                          [openDelay]="150"
                          [disableTooltip]="!navServices.collapseSidebar">
                          <app-svg-icon [icon]="'assets/images/sidebar/notification.svg'"></app-svg-icon>

                          @if (!navServices.collapseSidebar) {
                            <span>Notification</span>
                          }
                        </a>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ul>
        </div>
        <button class="right-arrow"
          id="right-arrow"
          [class.d-none]="rightArrowNone"
          (click)="scrollToRight()"
          aria-label="Scroll right">
          <app-feather-icons [icon]="'arrow-right'"></app-feather-icons>
        </button>
      </nav>
